// Bank accounts and credit cards money goes through ("Paid from" / "Received into").

export const bankAccountsOf = (assets = []) => assets.filter((a) => a.category === "account");

// The day the first bank account or card was added. Entries dated from then on must
// say which account or card they went through; older ones don't have to.
export const trackingSince = (assets = [], cards = []) => {
  const dates = [...bankAccountsOf(assets), ...cards].map((x) => String(x.createdAt || "").slice(0, 10)).filter(Boolean);
  return dates.length ? dates.sort()[0] : null;
};

export const sourceRequired = (date, assets, cards) => {
  const since = trackingSince(assets, cards);
  return !!since && !!date && date >= since;
};

// Select values are "account:<id>" / "card:<id>", or "" for none.
export const paidFromValue = (bill) => (bill && bill.paidFromKind ? `${bill.paidFromKind}:${bill.paidFromId}` : "");
export const paidFromFields = (value) => {
  if (!value) return { paidFromKind: null, paidFromId: null };
  const [kind, id] = value.split(":");
  return { paidFromKind: kind, paidFromId: Number(id) };
};

// "Received into" uses the same select, with bank accounts only.
export const receivedIntoValue = (income) => (income && income.receivedIntoId ? `account:${income.receivedIntoId}` : "");
export const receivedIntoId = (value) => (value ? Number(value.split(":")[1]) : null);

// A Paid expense (or Received money) dated after tracking started that doesn't say
// where the money went: shown as needing it.
export const missingPaidFrom = (bill, assets, cards) => bill.status === "Paid" && !bill.paidFromKind && sourceRequired(bill.dueDate, assets, cards);
export const missingReceivedInto = (income, assets, cards) =>
  income.status === "Received" && !income.receivedIntoId && bankAccountsOf(assets).length > 0 && sourceRequired(income.date, assets, cards);

// The account / card of a bank SMS: the one whose last 4 digits it mentions, if that
// was added on or before the message's date. `digits` come from parseSms.
export const sourceForDigits = (digits, date, assets = [], cards = []) => {
  if (!digits) return null;
  const addedBy = (x) => !x.createdAt || String(x.createdAt).slice(0, 10) <= date;
  const card = cards.find((c) => c.last4 === digits && addedBy(c));
  if (card) return { kind: "card", id: card.id };
  const account = bankAccountsOf(assets).find((a) => a.last4 === digits && addedBy(a));
  return account ? { kind: "account", id: account.id } : null;
};
